import type { Obstacle, Point } from "./model.js";

export function distance(a: Point, b: Point): number {
  return Math.hypot(a.x - b.x, a.y - b.y);
}
export function angleDifference(to: number, from: number): number {
  return Math.atan2(Math.sin(to - from), Math.cos(to - from));
}
export function rotateTowards(from: number, to: number, maximum: number): number {
  return from + Math.max(-maximum, Math.min(maximum, angleDifference(to, from)));
}
export function segmentCircleHit(
  start: Point,
  end: Point,
  circle: Point & { radius: number },
): number | null {
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const ox = start.x - circle.x;
  const oy = start.y - circle.y;
  const a = dx * dx + dy * dy;
  const c = ox * ox + oy * oy - circle.radius * circle.radius;
  if (c <= 0) return 0;
  if (a === 0) return null;
  const b = 2 * (ox * dx + oy * dy);
  const discriminant = b * b - 4 * a * c;
  if (discriminant < 0) return null;
  const hit = (-b - Math.sqrt(discriminant)) / (2 * a);
  return hit >= 0 && hit <= 1 ? hit : null;
}
export function hasLineOfSight(a: Point, b: Point, obstacles: Obstacle[]): boolean {
  return obstacles.every((obstacle) => segmentCircleHit(a, b, obstacle) === null);
}
